import React from 'react';
import AssistantWorkspaceChat from './AssistantWorkspaceChat';

const AssistantAI = () => {
  return (
    <div>
      <AssistantWorkspaceChat />
    </div>
  );
};

export default AssistantAI;